import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserToken = () => {
      const Info = localStorage.getItem("info");
      const userToken = JSON.parse(Info)?.token;

      if (!userToken || userToken === "undefined") {
        setIsLoggedIn(false);
        navigate("/");
      } else {
        setIsLoggedIn(true);
      }
      setIsLoading(false);
    };

    checkUserToken();
  }, [navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isLoggedIn ? (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ width: "100%" }}>{children}</div>
    </div>
  ) : null;
};

export default ProtectedRoute;